module.exports = __webpack_public_path__ + "img/vertical_7_4_9006.cb9fdc6f.png";